export default __webpack_public_path__ + "static/icon-10-1-86ddd4b6a9ea5db15eb298079472d560.png";